import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowRight, Radar, Lock, ServerCog, LifeBuoy } from "lucide-react";
import { siteData } from "../mock";
import Starfield from "./Starfield";

const iconsBySlot = [Radar, ServerCog, Lock, LifeBuoy];

const Security = () => {
  return (
    <section className="relative py-28 overflow-hidden bg-[#05070d] text-white">
      <div className="absolute inset-0">
        <img
          src={siteData.images.security}
          alt="Deep space with stars"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#05070d] via-[#05070d]/80 to-[#05070d]/60" />
      </div>
      <Starfield count={35} />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div>
          <p className="text-xs font-semibold tracking-[0.25em] text-blue-300">
            {siteData.security.eyebrow}
          </p>
          <h2 className="mt-3 text-3xl md:text-5xl font-bold tracking-tight leading-[1.05]">
            Recover fast. Stay online. <span className="gradient-text">Sleep at night.</span>
          </h2>
          <p className="mt-5 text-white/75 leading-relaxed max-w-xl">
            {siteData.security.body}
          </p>
          <Link
            to="/contact"
            className="mt-7 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 font-semibold transition-all shadow-[0_10px_30px_-10px_rgba(99,102,241,0.7)] hover:-translate-y-0.5"
          >
            Get a security review
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {siteData.security.bullets.map((b, i) => {
            const Icon = iconsBySlot[i % iconsBySlot.length] || ShieldCheck;
            return (
              <div
                key={i}
                className="group relative p-6 rounded-2xl grad-border overflow-hidden hover:-translate-y-1 transition-all"
              >
                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-blue-500/25 to-purple-500/10 border border-blue-400/30 flex items-center justify-center text-blue-300 mb-4 group-hover:text-white group-hover:from-blue-500 group-hover:to-indigo-500 transition-all">
                  <Icon className="w-5 h-5" />
                </div>
                <p className="font-semibold text-white">{b}</p>
                <span className="absolute right-4 top-4 text-xs font-mono text-white/30 group-hover:text-blue-300 transition-colors">0{i + 1}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Security;
